import { render } from "./ClientSettings.vue?vue&type=template&id=12af31e7&scoped=true"
import script from "./ClientSettings.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ClientSettings.vue?vue&type=script&charset=utf-8&lang=js"

import "./ClientSettings.vue?vue&type=style&index=0&id=12af31e7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12af31e7"]])

export default __exports__